import React, { useState } from "react";
import Card from "./Card";
import Button from "./Button";
import API from "../api/api";

export default function SubirFactura() {
  const [archivo, setArchivo] = useState(null);
  const [emailFinanzasEmisorOriginal, setEmailFinanzasEmisorOriginal] = useState("");
  const [emailFinanzasReceptorOriginal, setEmailFinanzasReceptorOriginal] = useState("");
  const [subiendo, setSubiendo] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (!archivo) {
      setError("Seleccione un archivo XML.");
      setMensaje("");
      return;
    }
    if (!emailFinanzasEmisorOriginal.trim()) {
      setError("Ingrese el email financiero del emisor original.");
      setMensaje("");
      return;
    }
    if (!emailFinanzasReceptorOriginal.trim()) {
      setError("Ingrese el email financiero del receptor original.");
      setMensaje("");
      return;
    }

    console.log("Archivo seleccionado:", archivo);

    const formData = new FormData();
    formData.append("archivo_xml", archivo);
    formData.append("email_finanzas_emisor_original", emailFinanzasEmisorOriginal.trim());
    formData.append("email_finanzas_receptor_original", emailFinanzasReceptorOriginal.trim());

    try {
      setSubiendo(true);
      setError("");
      setMensaje("");

      const token = localStorage.getItem("access");
      console.log("Authorization header presente:", Boolean(token));

      const response = await API.post("/facturas/subir/", formData);
      console.log("RESPONSE:", response);

      setMensaje("Factura enviada a revisión");
      setArchivo(null);
      setEmailFinanzasEmisorOriginal("");
      setEmailFinanzasReceptorOriginal("");
    } catch (err) {
      console.error("ERROR RESPONSE:", err.response || err);
      const backendError =
        err.response?.data?.archivo_xml?.[0] ||
        err.response?.data?.email_finanzas_emisor_original?.[0] ||
        err.response?.data?.email_finanzas_receptor_original?.[0] ||
        err.response?.data?.cdc?.[0] ||
        err.response?.data?.detail ||
        "No se pudo subir la factura.";

      setError(backendError);
      setMensaje("");
    } finally {
      setSubiendo(false);
    }
  };

  return (
    <Card className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold text-primary">
          Cargar factura electrónica
        </h2>
        <p className="text-sm text-slate-600 mt-1">
          Suba el archivo XML o YML de la factura para enviarlo a revisión.
        </p>
      </div>

      <input
        type="file"
        accept=".xml,.yml,.yaml,text/xml,application/xml"
        onChange={(e) => {
          setArchivo(e.target.files?.[0] || null);
          setError("");
          setMensaje("");
        }}
        className="block w-full text-sm"
      />

      <input
        type="email"
        placeholder="Email financiero del emisor original"
        value={emailFinanzasEmisorOriginal}
        onChange={(e) => {
          setEmailFinanzasEmisorOriginal(e.target.value);
          setError("");
          setMensaje("");
        }}
        className="border rounded p-2 w-full text-sm"
      />

      <input
        type="email"
        placeholder="Email financiero del receptor original"
        value={emailFinanzasReceptorOriginal}
        onChange={(e) => {
          setEmailFinanzasReceptorOriginal(e.target.value);
          setError("");
          setMensaje("");
        }}
        className="border rounded p-2 w-full text-sm"
      />

      {mensaje && (
        <p className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded p-3">
          {mensaje}
        </p>
      )}

      {error && (
        <p className="text-sm text-red-700 bg-red-50 border border-red-200 rounded p-3">
          {error}
        </p>
      )}

      <Button onClick={handleSubmit} disabled={subiendo}>
        {subiendo ? "Subiendo..." : "Subir factura"}
      </Button>
    </Card>
  );
}
